import { useQuery } from "react-query";
import axios, { AxiosResponse } from "axios";
import useLayoutStore, { Layout } from "../state/LayoutStore";

export default function useLayout() {
  async function retrieveLayoutData(): Promise<Layout> {
    const layoutApiUrl: string = process.env.REACT_APP_API_LAYOUT_URL || "";

    return await axios.get(layoutApiUrl);
  }

  return useQuery("layout", async () => await retrieveLayoutData(), {
    initialData: {},
    retry: 3,
    refetchOnWindowFocus: false,
    onSuccess: (response: AxiosResponse<Layout>) => {
      useLayoutStore.setState({ layout: response.data });
    },
  });
}
